// extracted by mini-css-extract-plugin
export default {"wrapper":"Status-module__wrapper--c7e04","left":"Status-module__left--f71b1","right":"Status-module__right--f15fe"};